import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface UserConfig {
  id?: number,
  email: String,
  isActive: Boolean
}

export interface LoggingUser {
  id?: number,
  email: String,
  firstName: String,
  lastName: String,
}


export interface FileManagementUser {
  id: number,
  email: string,
  fullName: string,
  nameShortcut: string,
  title: string,
  telephone: string,
  mobile: string,
}

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {

  private PATH = "/api/v1/user-config";
  private PATH2 = "/appliances/api/v2/auth";

  private PATH3 = "/appliances/api/v2/user"

  constructor(private httpClient: HttpClient) { }

  public updateIsAction(config: any) {
    const headers = new HttpHeaders({
      Authorization: sessionStorage.getItem('basicauth') || ''
    });
    // console.log("Config Object: ", config.email , config.isActive);

    return this.httpClient.post<any[]>(`${this.PATH}/`, config, { headers })
      .pipe(
        catchError(error => {
          console.error('Error occurred:', error);
          return throwError(error);
        })
      );
  }


  public checkUserIsActive(email: string): Observable<boolean> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });

    const params = new HttpParams().set('email', email);
    return this.httpClient.get<boolean>(`${this.PATH}/isActive`, { headers, params });
  }

  public getLoggingUser(): Observable<LoggingUser> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<LoggingUser>(`${this.PATH2}/LoggedInUser`, { headers });
  }


  public getFileManagementUsers(): Observable<FileManagementUser[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<FileManagementUser[]>(`${this.PATH3}/file-management-users`, { headers });
  }


  public getFileManagementUser(email: any): Observable<FileManagementUser> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.get<FileManagementUser>(`${this.PATH3}/file-management-users`, { headers });
  }

}
